<!-- search bar -->
<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2>{{ 'IRONSIDE.yellow-focus.title' | translate }}</h2>
        </div>
    </div>
</div>
<div class="list-yellow list-fournisseur">
    <div class="container">
        <div class="col-12 p-0 pl-3">
            <!-- <div class="wrap-pagination">
                <div class="d-flex justify-content-between  mb-3">
                    <div class="wrap-rows">
                        {{ 'IRONSIDE.yellow-focus.show' | translate }}
                        <p-dropdown [(ngModel)]="pageSize" (ngModelChange)="getListYellowFocus()" class="item-page"
                            [options]="listRows" optionLabel=""></p-dropdown>{{ 'IRONSIDE.yellow-focus.elements' | translate }}
                    </div>
                    <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="pageSize"
                        [totalRecords]="totalRecords" [showFirstLastIcon]="false"
                        [showCurrentPageReport]="false"></p-paginator>
                </div>
            </div> -->
            <div class="product-content d-flex flex-wrap">
                <div class="yellow-focus-item" *ngFor="let new of listYellowFocus">
                    <div class="item-news" (click)="showNewsDetail(new?.id)">
                        <div class="relative" style="height: 230px; margin-bottom: 12px">
                            <img
                                *ngIf="new?.imageURL"
                                [src]="new?.imageURL"
                                alt=""
                                class="w-full border-round"
                            />
                            <p-skeleton
                                *ngIf="!new?.imageURL"
                                width="100%"
                                height="100%"
                            ></p-skeleton>
                        </div>
                        <p class="title-news font-bold mb-2">
                            {{ new?.title | translateDynamicLanguage }}
                        </p>
                        <p class="desc mb-1">
                            {{ new?.description | translateDynamicLanguage }}
                        </p>
                        <div class="d-flex justify-content-between align-items-center">
                            <a>{{ 'IRONSIDE.yellow-focus.learn-more' | translate }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap-pagination">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="wrap-rows">
                        {{ 'IRONSIDE.yellow-focus.show' | translate }}
                        <p-dropdown
                            [(ngModel)]="pageSize"
                            (ngModelChange)="getListYellowFocus()"
                            class="item-page"
                            [options]="listRows"
                            optionLabel=""
                        ></p-dropdown
                        >{{ 'IRONSIDE.yellow-focus.elements' | translate }}
                    </div>
                    <p-paginator
                        (onPageChange)="onPageChange($event)"
                        [first]="first"
                        [rows]="pageSize"
                        [totalRecords]="totalRecords"
                        [showFirstLastIcon]="false"
                        [showCurrentPageReport]="false"
                    ></p-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
